module.exports = __webpack_public_path__ + "media/custom/images/img35-3e9ee67fa69e215baa2f755b7520c24b.jpg";